import { createPortal } from 'react-dom';

export default function Toast({ message }: { message: string | null }) {
  if (!message) return null;

  return createPortal(
    <div className="pointer-events-none fixed inset-x-0 top-24 z-[100] flex justify-center px-4">
      <div className="animate-fade-up flex items-center gap-2 rounded-full bg-foreground-950/92 px-5 py-3 text-sm font-medium text-background-50 shadow-lg backdrop-blur">
        <i className="ri-information-line text-base text-accent-400"></i>
        <span>{message}</span>
      </div>
    </div>,
    document.body,
  );
}